module.exports = __webpack_public_path__ + "img/prasarbharati.1555a051.jpg";